/**
 * ThumbDownIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ThumbDownIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M11.054 18.71a2.485 2.485 0 0 0 3.887.066l.133-.177c.292-.423.448-.927.449-1.442v-2.52h2.345c.852 0 1.646-.426 2.12-1.133l.328-.49.076-.12a2.55 2.55 0 0 0 .256-2.005l-1.359-4.721a2.55 2.55 0 0 0-2.45-1.845h-6.29a2.55 2.55 0 0 0-1.866.814l-.141.15a1.8 1.8 0 0 0-1.598-.967H5.056c-.997 0-1.806.809-1.806 1.806v7.388c0 .997.809 1.806 1.806 1.806h1.888c.448 0 .857-.164 1.172-.434zm-5.998-4.89a.306.306 0 0 1-.306-.306V6.126c0-.169.137-.306.306-.306h1.888c.169 0 .306.137.306.306v7.388a.306.306 0 0 1-.306.306zm8.728 4.002a.985.985 0 0 1-1.464.062l-.076-.088-3.494-4.55V7.27l1.031-1.111a1.05 1.05 0 0 1 .769-.335h6.289c.467 0 .879.31 1.009.76l1.358 4.721c.085.296.036.617-.137.875l-.328.49a1.05 1.05 0 0 1-.873.467h-3.095a.75.75 0 0 0-.75.75v3.27c0 .244-.086.48-.239.666"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ThumbDownIcon = makeIcon('ThumbDownIcon', ThumbDownIconSvg)
